import { FunctionComponent } from 'react';
import { Navigate, Route } from 'react-router-dom';
import { SentryRoutes as Routes } from '../sentry';
import { useBatchApi } from '../hooks';
import {
  GaIntake,
  GenericIntake,
  HiIntake,
  PaIntake,
  StateIntakeSuccess,
} from './state_intake';
import { BatchApiStatusHandler } from '../components';
import { StateSetupProps } from '../types';

export const StateSetup: FunctionComponent = () => {
  const batchResponse = useBatchApi([
    {
      url: '/api/legal_entity/people',
      method: 'GET',
    },
  ]);

  const componentPropsFn = ([peopleResponse]: any[]): StateSetupProps => {
    return {
      peopleData: peopleResponse,
    };
  };

  return (
    <section className="h-full">
      <Routes>
        <Route index element={<Navigate to="/" replace />} />
        <Route path=":locationId/success" element={<StateIntakeSuccess />} />
        <Route
          path="/ga"
          element={
            <BatchApiStatusHandler
              batchResponse={batchResponse}
              component={GaIntake}
              componentProps={componentPropsFn}
            />
          }
        />
        <Route
          path="/hi"
          element={
            <BatchApiStatusHandler
              batchResponse={batchResponse}
              component={HiIntake}
              componentProps={componentPropsFn}
            />
          }
        />
        <Route
          path="/pa"
          element={
            <BatchApiStatusHandler
              batchResponse={batchResponse}
              component={PaIntake}
              componentProps={componentPropsFn}
            />
          }
        />
        <Route
          path="/:locationId"
          element={
            <BatchApiStatusHandler
              batchResponse={batchResponse}
              component={GenericIntake}
              componentProps={componentPropsFn}
            />
          }
        />
      </Routes>
    </section>
  );
};

export default StateSetup;
